interface RequestParams {
  [name: string]: string | boolean | undefined;
}

enum Method {
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export const getApiUrl = (remain: string, params?: RequestParams) => {
  const baseApiUrl = import.meta.env.VITE_APP_API_URL ? import.meta.env.VITE_APP_API_URL : window.location.origin;
  const url = new URL(remain, baseApiUrl);
  if (params) {
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined) {
        url.searchParams.append(key, typeof params[key] === 'boolean' ? (params[key] as boolean).toString() : (params[key] as string));
      }
    });
  }

  return url;
};

const sendAsync = async (
  remain: string,
  method: Method,
  params?: RequestParams,
  body?: any,
  skipResponseBody?: boolean,
  plainTextRequestBody?: boolean,
  hideLoader = false
) => {
  !hideLoader && window.dispatchEvent(new CustomEvent('showLoader'));
  const url = getApiUrl(remain, params);  
  const requestVerificationToken = document?.querySelector<HTMLInputElement>('#RequestVerificationToken');
  const requestVerificationTokenValue = requestVerificationToken && requestVerificationToken.value;
  const requestInit: RequestInit = {
    method: method,
  };
  interface MyHeader {
    'Content-Type'?: string;
    [key: string]: any;
  }
  let requestHeader: MyHeader = {};
  requestHeader['Content-Type'] = 'application/json';

  requestVerificationTokenValue && method == Method.POST && (requestHeader['RequestVerificationToken'] = requestVerificationTokenValue);

  if (body) {
    if (body instanceof FormData) {
      requestInit.body = body;
    } else if (body instanceof Object) {
      requestInit.body = JSON.stringify(body);
      requestInit.headers = requestHeader;
    } else {
      requestInit.body = body;
      if (!plainTextRequestBody) {
        requestInit.headers = requestHeader;
      }
    }
  }

  return skipResponseBody
    ? fetch(url, requestInit).finally(() => {
        window.dispatchEvent(new CustomEvent('removeLoader'));
      })
    : fetch(url, requestInit)
        .then(async (res) => {
          if (!res.headers.get('content-type')) {
            return res?.status ? res?.status : null;
          } else if (
            res.headers.get('content-type')?.includes('text/xml') ||
            res.headers.get('content-type')?.includes('text/plain') ||
            res.headers.get('content-type')?.includes('text/html')
          ) {
            return res.text();
          }
          return res.json();
        })
        .finally(() => {
          window.dispatchEvent(new CustomEvent('removeLoader'));
        });
};

export const getAsync = async (remain: string, params?: RequestParams, hideLoader?: boolean) => {
  return sendAsync(remain, Method.GET, params, undefined, undefined, undefined, hideLoader);
};

export const postAsync = async (
  remain: string,
  params?: RequestParams,
  body?: any,
  skipResponseBody?: boolean,
  plainTextRequestBody?: boolean,
  hideLoader?: boolean
) => {
  return sendAsync(remain, Method.POST, params, body, skipResponseBody, plainTextRequestBody, hideLoader);
};

export const putAsync = async (
  remain: string,
  params?: RequestParams,
  body?: any,
  skipResponseBody?: boolean,
  plainTextRequestBody?: boolean,
  hideLoader?: boolean
) => {
  return sendAsync(remain, Method.PUT, params, body, skipResponseBody, plainTextRequestBody, hideLoader);
};

export const patchAsync = async (
  remain: string,
  params?: RequestParams,
  body?: any,
  skipResponseBody?: boolean,
  plainTextRequestBody?: boolean,
  hideLoader?: boolean
) => {
  return sendAsync(remain, Method.PATCH, params, body, skipResponseBody, plainTextRequestBody, hideLoader);
};

export const deleteAsync = async (
  remain: string,
  params?: RequestParams,
  body?: any,
  skipResponseBody?: boolean,
  plainTextRequestBody?: boolean,
  hideLoader?: boolean
) => {
  return sendAsync(remain, Method.DELETE, params, body, skipResponseBody, plainTextRequestBody, hideLoader);
};
